export default __webpack_public_path__ + "static/media/truck.c8d8fb41.svg";